export const ACTIVE_COMPOSITE_ITEM = 'data-composite-item-active';
